module.exports = __webpack_public_path__ + "img/icon2.274e42c0.svg";